<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section">
        <el-form
          label-width="50px"
          label-position="right"
          inline
          style="height:100%"
        >
          <el-form-item :label="$t('Menu.Search')">
            <el-input v-model="txtSearch" :placeholder="$t('Menu.SearchTitle')" style="width:200px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left: 5px" @click="clickQueryHandler">{{ $t('Menu.Search') }}</el-button>
            <el-button type="primary" style="margin-left: 5px" @click="addCustomerHandler">{{ $t('Menu.Add') }}</el-button>
            <el-button type="primary" style="margin-left: 5px" @click="updateClickHandler">{{ $t('Menu.Update') }}</el-button>
            <el-button type="danger" style="margin-left: 5px" @click="onRemove">{{ $t('Menu.delete') }}</el-button>
            <el-button type="primary" style="margin-left: 5px" @click="initDataClickHandler">{{ $t('Menu.BasicData') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="9300001"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="clickQueryHandler"
        />
      </div>
    </div>
    <tenant-window
      :visible.sync="tenantWindow.visible"
      :is-show-admin="tenantWindow.isShowAdmin"
      :tenant="tenantWindow.tenant"
      @successCallBack="clickQueryHandler"
      @close="tenantWindow.visible=false"
    />
    <tenant-standard-window
      :visible.sync="tenantStandardWindow.visible"
      :tenant-obj="tenantStandardWindow.tenantObj"
      @close="tenantStandardWindow.visible=false"
    />
    <init-data-window
      :visible.sync="initDataWindow.visible"
      :obj="initDataWindow.obj"
      @close="initDataWindow.visible=false"
    />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected } from '@/utils/agGrid'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import TenantWindow from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/TenantWindow'
import SysMenuByAddTenantWindow from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/SysMenuByAddTenantWindow'
import TenantStandardWindow from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/TenantStandardWindow'
import InitDataWindow from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/InitDataWindow'
import * as initalDataApi from '@/api/sysManage/baseConfig/initalData'
import * as customerApi from '@/api/partner/customer'
import { DocumentManage } from '@/utils/commonUtil'

export default {
  name: 'CustomerAutomation',
  components: { cargoAdvanceSelect, TenantWindow, SysMenuByAddTenantWindow, TenantStandardWindow, InitDataWindow },
  data() {
    return {
      isEdit: false,
      txtSearch: '',
      documentManage: new DocumentManage(),
      selectTypeNames: TYPE_NAMES,
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Menu.Numbering'),
          field: 'tenantId',
          width: 150
        },
        {
          headerName: this.$t('Menu.CompanyName'),
          field: 'name',
          width: 150
        },
        {
          headerName: this.$t('Menu.CompanyCode'),
          field: 'code',
          width: 150
        },
        {
          headerName: this.$t('Menu.CompanyPhone'),
          field: 'phone',
          width: 150
        },
        {
          headerName: this.$t('Menu.CompanyEMail'),
          field: 'email',
          width: 150
        },
        {
          headerName: this.$t('Menu.CreateDate'),
          field: 'createDate',
          width: 150
        }
      ],
      rowData: [],
      sourceData: [],
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      sysMenuWindow: {
        visible: false,
        title: '',
        sysMenu: {},
        saveCallBack: () => {}
      },
      tenantWindow: {
        visible: false,
        isShowAdmin: false,
        tenant: {}
      },
      tenantStandardWindow: {
        tenantObj: {},
        visible: false
      },
      initDataWindow: {
        obj: {},
        visible: false
      }
    }
  },
  methods: {
    clickQueryHandler() {
      const params = {}
      params.name = this.txtSearch
      params.pageSize = this.filter.pageSize
      params.currentPage = this.filter.pageNum
      customerApi.queryCustomerPageable(params).then(resp => {
        this.rowData = resp.data.results
        this.filter.pageNum = resp.data.currentPage
        this.filter.pageSize = resp.data.pageSize
        this.total = Number(resp.data.totalSize)
      })
    },
    addCustomerHandler() {
      this.tenantWindow.tenant = {}
      this.tenantWindow.isShowAdmin = true
      this.tenantWindow.visible = true
    },
    updateClickHandler() {
      const data = this.gridOptions.api.getSelectedRows()
      if (data && data.length === 1) {
        this.tenantWindow.tenant = data[0]
        this.tenantWindow.isShowAdmin = false
        this.tenantWindow.visible = true
      } else {
        this.$message.warning(this.$t('Menu.UpdateData'))
      }
    },
    async onRemove() {
      await this.$confirm('你确定要删除吗？')
      const data = this.gridOptions.api.getSelectedRows()
      if (data && data.length > 0) {
        const listKey = []
        const listTenant = []
        for (const obj of data) {
          listKey.push(obj.uuid)
          listTenant.push(obj.tenantId)
        }
        const params = {}
        params.uuids = listKey
        params.tenantIds = listTenant
        const loading = getLoading()
        customerApi.delCustomer(params).then(resp => {
          this.clickQueryHandler()
          this.$message.warning(this.$t('Menu.SuccessfullyDeleted'))
        }).finally(() => loading.close())
      } else {
        this.$message.warning(this.$t('Menu.DeleteData'))
      }
    },
    initDataClickHandler() {
      const data = this.gridOptions.api.getSelectedRows()
      if (data && data.length === 1) {
        const obj = data[0]
        initalDataApi.queryInitalDataByTenantId({ tenantId: obj.tenantId }).then(resp => {
          this.queryResult(resp)
        })
      } else {
        this.$message.warning(this.$t('Menu.InitData'))
      }
    },
    queryResult(resp) {
      const result = resp.data
      if (result) {
        this.initDataWindow.obj = result
        this.initDataWindow.visible = true
      } else {
        const data = this.gridOptions.api.getSelectedRows()
        if (!data || data.length === 0) {
          return
        }
        this.tenantStandardWindow.tenantObj = data[0]
        this.tenantStandardWindow.visible = true
      }
    }
  }
}
</script>

<style scoped>

</style>
